import { useMemo } from 'react';
import { Check, Download, Exclamation, Eye, EyeSlash } from 'react-bootstrap-icons';
import '../../styles/woot.fba.css';

interface WootFbaJourneyStep {
  title: string;
  item: any;
  itemRequiresParse: boolean;
  handleDownloadFile: any
  isPreviewable: boolean
  handlePreviewFile: any
  isSuccess: boolean
}

export default function WootFbaJourneyStep({ 
  title, 
  item, 
  itemRequiresParse, 
  handleDownloadFile,
  isPreviewable,
  handlePreviewFile,
  isSuccess
}: WootFbaJourneyStep) {
  const view = useMemo(() => {
    const iconProps = {
      size: 32,
      color: isSuccess ? 'green' : 'orange',
    };

    return (
      <div className={`journey-step ${isSuccess ? 'success' : 'warning'}`}>
        <div className="journey-icon">
          {isSuccess ? <Check {...iconProps} /> : <Exclamation {...iconProps} />}
        </div>
        <div className="journey-title">{title}</div>
        {isSuccess && (
          <div className="journey-subtext">{item?.split('/').pop()}</div>
        )}
        <br/>
        {isSuccess && isPreviewable && item !== 'NOT REQUIRED' && (
          <span style={{float: 'left'}} onClick={handlePreviewFile} data-path={item} title={`Click to Preview ${item.split('/').pop()}`} className='beacon-link'>
            <Eye height={20} width={20}/>
          </span>
        )}
        {isSuccess && (!isPreviewable || item === 'NOT REQUIRED') && (
          <span style={{float: 'left'}} data-path={item} title={`No preview available for ${item.split('/').pop()}`} className='beacon-link'>
            <EyeSlash height={20} width={20}/>
          </span>
        )}
        {isSuccess && item !== 'NOT REQUIRED' && (
          <span style={{float: 'right'}} onClick={handleDownloadFile} data-path={item} title={`Click to Download ${item.split('/').pop()}`} className='beacon-link'>
            <Download height={20} width={20}/>
          </span>
        )}
        <br/>
      </div>
    );
  }, [title, item]);

  return view;
}
